import React from "react"
import { useParams } from "react-router-dom"
import { BarListItemComponent } from "../components/BarListItem"
import { DiggerIconComponent } from "../components/DiggerIcon"
import { diggers } from "../data/diggers"
import {
  getDiggerBadges,
  getDiggerBars,
  getDiggerLevel,
  getDiggerLevelUnique,
  getDiggerMiles,
} from "../service/diggerMethods"
import style from "./Digger.module.scss"
import { BadgeList } from "./BadgeList"

export const DiggerComponent: React.FC = () => {
  const params = useParams()
  const digger = diggers.find((digger) => digger.id === params.id)
  if (!digger)
    return <span className="errorPage">Такой страницы не существует :(</span>

  const diggerMiles = getDiggerMiles(digger)
  const diggerBars = getDiggerBars(digger)
  const diggerBadges = getDiggerBadges(digger)

  const level = getDiggerLevel(digger)
  const levelUnique = getDiggerLevelUnique(digger)

  return (
    <>
      <div className={style.diggerPage}>
        <div className={style.black}>
          <div className={style.cardCenter}>
            <DiggerIconComponent digger={digger} />
          </div>
          {digger.bio?.split("\n").map((par) => (
            <div className={style.bio}>{par}</div>
          ))}
          <br />
          <BadgeList badgeList={diggerBadges} />
          <br />
          <h2>Участник миль</h2>
          <div className="diggerMiles">
            {diggerMiles.map((mile, index) => (
              <img key={index} src={`/images/${mile.image}.png`} alt="" />
            ))}
          </div>
          <br />
          <p className={style.level}>Всего баров: {level}</p>
          <p className={style.level}>Уникальных баров: {levelUnique}</p>
          <br />
          <h2>Посещены бары</h2>
          <div className={style.barList}>
            {Object.values(diggerBars).map((mile) => {
              return mile.bars.map((bar, index2) => (
                <BarListItemComponent
                  key={index2}
                  bar={bar}
                  image={mile.image}
                />
              ))
            })}
          </div>
        </div>
      </div>
    </>
  )
}
